import { ErrorBoundary } from '@monorepo/shared/componentsV2/ErrorBoundary';
import { RoutesWith404 } from '@monorepo/shared/componentsV2/RoutesWith404';
import { useIsSuperAdmin } from '@monorepo/shared/hooks/permissions/useIsSuperAdmin';
import { useFeatureFlags } from 'mapistry-shared/api';
import React from 'react';
import { Route } from 'react-router-dom';
import {
  EditLogFields,
  EditLogFormulas,
  EditLogPage,
  EditLogSites,
  Mode,
} from './components/EditLogPage';
import {
  WizardStep,
  WizardStepUrlPart,
} from './components/EditLogPage/EditLogHeader';
import { EditLogPageAiConfig } from './components/EditLogPage/EditLogPageAiConfig';
import { LogAnalyticsSyncPage } from './components/EditLogPage/LogAnalyticsSyncPage';
import { LogDetail } from './components/LogDetail';
import { ViewLogs } from './components/ViewLogs';

export function LogDataSetupRouter() {
  const { isData2Enabled, hasOrgPaidForEdpAiUploader } = useFeatureFlags();
  const isSuperAdmin = useIsSuperAdmin();

  return isData2Enabled ? (
    <RoutesWith404>
      <Route
        index
        element={
          <ErrorBoundary>
            <ViewLogs />
          </ErrorBoundary>
        }
      />
      <Route path={Mode.new}>
        <Route
          index
          element={
            <ErrorBoundary>
              <EditLogPage />
            </ErrorBoundary>
          }
        />
      </Route>
      <Route path=":logId">
        <Route
          index
          element={
            <ErrorBoundary>
              <LogDetail />
            </ErrorBoundary>
          }
        />
        <Route path=":mode">
          <Route
            index
            element={
              <ErrorBoundary>
                <EditLogPage />
              </ErrorBoundary>
            }
          />
          <Route
            path={WizardStepUrlPart[WizardStep.FIELDS]}
            element={
              <ErrorBoundary>
                <EditLogFields />
              </ErrorBoundary>
            }
          />
          {hasOrgPaidForEdpAiUploader && (
            <Route
              path={WizardStepUrlPart[WizardStep.AI]}
              element={
                <ErrorBoundary>
                  <EditLogPageAiConfig />
                </ErrorBoundary>
              }
            />
          )}
          <Route
            path={WizardStepUrlPart[WizardStep.FORMULAS]}
            element={
              <ErrorBoundary>
                <EditLogFormulas />
              </ErrorBoundary>
            }
          />
          <Route
            path={WizardStepUrlPart[WizardStep.SITES]}
            element={<EditLogSites />}
          />
          {isSuperAdmin && (
            <Route
              path={WizardStepUrlPart[WizardStep.ANALYTICS_SYNC]}
              element={
                <ErrorBoundary>
                  <LogAnalyticsSyncPage />
                </ErrorBoundary>
              }
            />
          )}
        </Route>
      </Route>
    </RoutesWith404>
  ) : null;
}
